import { render, staticRenderFns } from "./NewFastOrder.vue?vue&type=template&id=88bcc1a0&scoped=true"
import script from "./NewFastOrder.vue?vue&type=script&lang=js"
export * from "./NewFastOrder.vue?vue&type=script&lang=js"
import style0 from "./NewFastOrder.vue?vue&type=style&index=0&id=88bcc1a0&prod&lang=css"
import style1 from "./NewFastOrder.vue?vue&type=style&index=1&id=88bcc1a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bcc1a0",
  null
  
)

export default component.exports